import React, { useState, useEffect, useCallback } from 'react';
import UserList from './UserList';

export const HELP_DESK_URL = 'https://contently-support.zendesk.com/hc/en-us/articles/21627510975378-What-are-the-user-roles-and-how-do-I-change-them';

export const FETCH_STATE = { LOADING: 0, SUCCESS: 1, ERROR: 2 };

// The polling interval, in ms (20000 => 20s)
const POLL_INTERVAL = 20000;

export default function CurrentlyEditingUsers({storyId}){
  const [users, setUsers] = useState([]);
  const [fetchState, setFetchState] = useState(-1);

  const performFetch = useCallback(() => {
    if (fetchState < 0) {
      setFetchState(FETCH_STATE.LOADING);
      fetch(`/api/v2/stories/${storyId}/editing_users`)
        .then(function(response) {
          response.json()
            .then(function(usersJSON){
              setUsers(usersJSON);
              setFetchState(FETCH_STATE.SUCCESS);
            })
            .catch(function(e){
              console.error('There was an error parsing current users response: ', e);
              setFetchState(FETCH_STATE.ERROR);
            })
        })
        .catch(function(e){
          console.error('There was an error fetching current users: ', e);
          setFetchState(FETCH_STATE.ERROR);
        })
    }
  }, [storyId, setUsers, setFetchState, FETCH_STATE.LOADING]);

  // one effect to perform the first fetch
  useEffect(performFetch, [performFetch]);

  // this effect to periodically rerun
  useEffect(() => {
    if(fetchState === FETCH_STATE.SUCCESS || fetchState === FETCH_STATE.ERROR){
      const timer = setTimeout(performFetch, POLL_INTERVAL);

      return () => clearTimeout(timer);
    }
  }, [fetchState, performFetch, FETCH_STATE.SUCCESS, FETCH_STATE.ERROR, POLL_INTERVAL]);

  return <UserList fetchState={fetchState} users={users} />;
}



// WEBPACK FOOTER //
// ./app/javascript/client/components/CurrentlyEditingUsers/index.jsx